import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .switch {
    position: relative;
    width: 26px;
    height: 14px;
    border: 2px solid ${colors.grey};
    background-color: ${colors.silver};
    border-radius: 7px;
    cursor: pointer;

    .switchSlider {
      width: 6px;
      height: 6px;
      position: relative;
      top: calc(50% - 12px);
      left: 2px;
      transition: transform 0.3s ease;
    }

    .switchSlider.active {
      transform: translateX(13px);
    }
  }

  .switch.active {
    border: 2px solid ${colors.green};
    background-color: ${colors.darkGreen};
  }

  .switchText {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    line-height: 20px;
    color: ${colors.silver};
    margin-left: 5px;
    transition: color 0.3s ease;
  }

  .switchText.active {
    color: ${colors.green};
  }
`;
